





































import { Vue } from 'vue-property-decorator'
import '../../styles/view-tile.css'
import AlertThumbnail from './AlertThumbnail.vue'
import IAlert from '../../viewModel/IAlert'
import { PropOptions } from 'vue'
import IAlertTag from '@/viewModel/IAlertTag'
export default Vue.extend({
  components: { AlertThumbnail },
  name: 'AlertList',
  props: {
    alerts: {
      type: Array,
      required: true,
    } as PropOptions<IAlert[]>,
    alertTags: {
      type: Array,
      required: true,
    } as PropOptions<IAlertTag[]>,
    showTitle: {
      type: Boolean,
      required: true,
    },
    showBorder: {
      type: Boolean,
      required: true,
    },
    isColumnLayout: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    markRead(id: number) {
      this.$emit('markRead', id)
    },
  },
})
